import React from 'react';
import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { IconVerfied } from '@prisjakt/ui/icon';

export const CornerBadge = () => {
  return (
    <Wrapper>
      <Badge color="yellove900" size={16} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  clip-path: polygon(0% 100%, 100% 0%, 0% 0%);
  background: ${p => p.theme.colors.yellove500};

  ${media.mediumUp`
    display: none;
  `}
`;

const Badge = styled(IconVerfied)`
  margin-top: 2px;
  margin-left: 2px;
`;
